import { SchedulesProcuredInput } from "generated/graphql"
import { getErrors } from "hooks/useErrors"
import produce from "immer"
import { validateSchedules } from "models/scheduling.yup"
import create from "zustand"

type GenerateTripStoreType = {
  schedules: any[]
  latestError: any
  setSchedules: (schedules: any[]) => void
  changeProcuredQuantity: (index: number, value: any) => void
  parsedSchedules?: () => SchedulesProcuredInput[]
}
export const useGenerateTripStore = create<GenerateTripStoreType>(
  (set, get) => ({
    schedules: [],
    latestError: null,
    setSchedules(schedules: any[]) {
      const errors = getErrors({
        schema: validateSchedules,
        state: schedules,
      })
      set({
        schedules: schedules?.map((schedule, idx) => ({
          ...schedule,
          errors: errors?.details?.[idx],
        })),
        latestError: errors?.latest,
      })
    },
    changeProcuredQuantity(index, value) {
      set(
        produce(state => {
          state.schedules[index].procuredQuantity =
            value || value === 0 ? Number(value) : ""
        })
      )
    },
    parsedSchedules() {
      return get().schedules?.map?.(sch => ({
        schedule: Number(sch.id),
        quantity: sch.procuredQuantity,
      }))
    },
  })
)
